<div class="min-h-screen bg-base-100">
  <app-error-toast></app-error-toast>
  <app-rate-limit-alert></app-rate-limit-alert>
  <router-outlet></router-outlet>
</div>
